export enum EmploymentScheduleType {
  UntilFurtherNotice = 'untilFurtherNotice',
  Hourly = 'hourly',
}
